type InputProps = {
  value: string | number;
  onChange: (value: string) => void
  placeholder?: string
  name?: string
  id?: string
  type?: string
  className?: string
  disabled?: boolean
}

export default function Input({
  value,
  onChange,
  placeholder = 'Enter value',
  name,
  id,
  type = 'text',
  className = 'form-control',
  disabled,
}: InputProps) {
  return (
    <input
      id={id}
      name={name}
      type={type}
      className={className}
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
    />
  )
}

